import React from "react";
import { Route, Switch } from "react-router-dom";
import DataTable from "../screens/Plimso/DataTable.jsx";

function NavigationRouter(){

    return (
      <Switch>
        
        <Route path="/" exact>
          <DataTable />
        </Route>                
      </Switch>
    );
  
}


export default NavigationRouter;